export default "__VITE_ASSET__BcNqj5Po__"